var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"btn btn-primary",attrs:{"href":_vm.link ? _vm.link : '#'}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }